import { FC } from "react";
import { InnerBox } from "@/components/elements/InnerBox";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { SharedTalentFileItem } from "@/features/sharing/components/SharedTalentFileItem";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider } from "@/theme/colors";
import { Stack, Box, Collapse } from "@mui/material";

type TSharedTalentCertificateFilesProps = {
  defaultValues?: Partial<TTalentForm>;
  shareUrl: string;
};

/** Certificate files section for shared talent page — uses shared signed URL API for file access */
export const SharedTalentCertificateFiles: FC<TSharedTalentCertificateFilesProps> = ({ defaultValues, shareUrl }) => {
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <CollapsibleSectionHeader title="証明書など" expanded={expanded} onToggle={toggle} />
      <Collapse in={expanded}>
        {defaultValues?.talentUploadFiles?.length ? (
          <Stack>
            {defaultValues.talentUploadFiles.map((item, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  mt: 2,
                }}
              >
                <SharedTalentFileItem
                  filePath={item.filePath}
                  shareUrl={shareUrl}
                  files={defaultValues.talentUploadFiles ?? undefined}
                  currentFileIndex={idx}
                  maxWidth={336}
                  updatedAt={item.updatedAt}
                />
              </Box>
            ))}
          </Stack>
        ) : null}
      </Collapse>
    </InnerBox>
  );
};
